export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "build/scripts/client-30ba0db85357508755a1.worker.js");
}
